// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pack-card[data-v-854ea304] {\n  border: 1px solid #E4E4E4;\n  border-radius: 4px;\n  height: 100%;\n}\n.descriiption[data-v-854ea304] {\n  font-size: 13px;\n  white-space: pre;\n}\n", ""]);
// Exports
module.exports = exports;
